
import { Component, Vue } from "vue-property-decorator";
import PaperResultAiH5 from "@/views/paper/paper-result-ai-h5.vue";

@Component({
  components: { PaperResultAiH5 }
})
export default class H5Report extends Vue {}
